import React, { useState } from 'react';
import { Box, Typography, IconButton, Skeleton, useTheme } from '@mui/material';
import CampaignIcon from '@mui/icons-material/Campaign';
import CloseIcon from '@mui/icons-material/Close';
import { useGetAnnouncementsQuery } from '@/features/announcements/announcementsApi';
import { useBannerColours } from '@/hooks/useBannerColours';

const AnnouncementBanner = () => {
	const theme = useTheme();
	const {
		backgroundColor,
		border,
		textColor: textColour,
		secondaryTextColor: secondaryTextColour,
	} = useBannerColours('info');

	const { data, isFetching } = useGetAnnouncementsQuery({});

	const [closed, setClosed] = useState(false);

	return (
		data?.subject &&
		!closed && (
			<Box px='1.5em'>
				<Box
					sx={{
						position: 'relative', // Needed for absolute positioning of the IconButton
						width: '100%',
						padding: '20px',
						marginTop: '1em',
						backgroundColor,
						borderRadius: '12px',
						display: 'flex',
						alignItems: 'center',
						border,
					}}
				>
					<CampaignIcon sx={{ fontSize: 50, color: theme.palette.primary.main }} />
					<Box sx={{ ml: 2, flexGrow: 1 }}>
						{/* flexGrow: 1 ensures this Box takes up the maximum width */}
						<Typography
							variant='body1'
							sx={{
								fontWeight: 700,
								color: textColour,
								mb: 0.5,
							}}
						>
							Announcements
						</Typography>
						<Typography sx={{ color: secondaryTextColour }} variant='body1'>
							{isFetching ? (
								<Skeleton variant='text' animation='wave' />
							) : (
								data?.subject
							)}
						</Typography>
					</Box>
					<IconButton
						onClick={() => setClosed(true)}
						sx={{
							color: secondaryTextColour,
							position: 'absolute', // Position the button absolutely...
							top: 8, // ...from the top of the parent Box
							right: 8, // ...and from the right of the parent Box
						}}
					>
						<CloseIcon sx={{ fontSize: '18px' }} />
					</IconButton>
				</Box>
			</Box>
		)
	);
};

export default AnnouncementBanner;
